import InventoryServiceHelper from './service.inventory.helper';

export default class InventoryService {

    static API_URI = 'admin';

    static login(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/sign-in`, payload);
    }

    static signup(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/register`, payload);
    }

    static createAdmin(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/create-admin`, payload);
    }

    static addStock(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/create-product`, payload);
    }

    static getAllStock(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.filter_by === 'type'){
            request_params += `&transaction_type=${params.filter}`;
        }
        if(params.status !== '' && params.status !== undefined) {
            request_params += `&status=${params.status}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filter_by=${params.filter_by}`;
        }
        if(params.sort_by !== '' && params.sort_by !== undefined) {
            request_params += `&sort_by=${params.sort_by}`;
        }
        if(params.download !== '' && params.download !== undefined && params.download === 'True') {
            request_params += `&download=${params.download}`;
        }
        if(params.gateway !== '' && params.gateway !== undefined) {
            request_params += `&gateway=${params.gateway}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        request_params = request_params.slice(1)
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/all-products?${request_params}`);
    }

    static getPricelist() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/pricelist/all`);
    }

    static getStockById(id) {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/product/${id}`);
    }

    static updateStock(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/product/${payload.id}`, payload);
    }

    static deleteStock(id) {
        return InventoryServiceHelper.handleDeleteRequest(`${this.API_URI}/product/${id}`);
    }

    static importStock(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/import-product`, payload);
    }

    static filterStock(params) {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/filter-product?page=${params.page}&sku=${params.sku}&name=${params.name}`);
    }

    static searchProducts(params) {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/filter-product?filter=${params}`);
    }

    static uploadProductImage(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/update-product-image/${payload.id}`, payload);
    }

    static scanBarcode(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/product/${payload.id}/barcode`, payload);
    }

    static stockAnalytics() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/get-analytics`);
    }

    static restockRequest(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/product-restock`, payload);
    }

    static stockRequests() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/restock`);
    }

    static manageStockRequest(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/restock-management`, payload);
    }

    static createVendor(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/create-vendor`, payload);
    }

    static getVendors() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/all-vendors`);
    }

    static getVendorById(vendor_id) {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/vendor/${vendor_id}`);
    }

    static updateVendor(payload) {
        return InventoryServiceHelper.handlePutRequest(`${this.API_URI}/vendor/${payload.vendor_id}`, payload);
    }

    static deleteVendor(vendor_id) {
        return InventoryServiceHelper.handleDeleteRequest(`${this.API_URI}/vendor/${vendor_id}`);
    }
    
    static createOrganisation(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/create-organisation/`, payload);
    }
    
    static wallxOnaboading(payload) {
        return InventoryServiceHelper.handlePostRequest('/wallx/onboarding', payload);
    }
    
    static logOutServer() {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/sign-out`, {});
    }
    
    static productSale(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/sales`, payload);
    }
    
    static getSalesAnalytics() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/sales/analytics`);
    }
    
    static getSalesChart() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/sales/analytics/chart`);
    }
    
    static downloadSalesChart(payload) {
        return InventoryServiceHelper.handleDownloadRequest(`${this.API_URI}/sales/analytics/chart/download?from_date=${payload.from_date}&to_date=${payload.to_date}`, 'Sales_Report');
    }


    static allSales(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filterBy=${params.filter_by}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        request_params = request_params.slice(1)
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/sales/list?${request_params}`);
    }
    
    // Storefront ***********************************************************************************************
    static getStorefrontProducts(payload) {
        let request_payload = ``;

        if(payload.filter !== '' && payload.filter !== undefined) {
            request_payload += `&q=${payload.filter}`;
        }
        if(payload.sortBy !== '' && payload.sortBy !== undefined) {
            request_payload += `&sortBy=${payload.sortBy}`;
        }
        if(payload.orderBy !== '' && payload.orderBy !== undefined) {
            request_payload += `&orderBy=${payload.orderBy}`;
        }
        if(payload.perPage !== '' && payload.perPage !== undefined) {
            request_payload += `&perPage=${payload.perPage}`;
        }
        if(payload.page !== '' && payload.page !== undefined) {
            request_payload += `&page=${payload.page}`;
        }
        request_payload = request_payload.slice(1)
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront?${request_payload}`);
    }

    static submitOrder(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/create-order`, payload);
    }

    static getOrder(payload) {
        let URI = `${this.API_URI}/storefront/order/${payload.order_id}`
        if(payload.query) {
            URI += `?department=${payload.query}`
        }
        return InventoryServiceHelper.handleGetRequest(URI);
    }

    static updateOrder(payload) {
        return InventoryServiceHelper.handlePutRequest(`${this.API_URI}/storefront/order/${payload.order_id}`, payload);
    }

    static changeOrderStatus(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/manage-order`, payload);
    }

    static deleteOrder(order_id) {
        return InventoryServiceHelper.handleDeleteRequest(`${this.API_URI}/storefront/order/${order_id}`);
    }

    static productUpload(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/upload-product`, payload);
    }

    static getBrandVAT(id) {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront/get-vat-status/${id}`);
    }

    static manageVAT(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/manage-vat`, payload);
    }

    static createStorefrontProduct(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/product/create`, payload);
    }

    static importStorefrontProduct(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/product/import`, payload);
    }

    static updateStorefrontProduct(payload, id) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/product/${id}`, payload);
    }

    static orderAnalytics() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront/order-analytics`);
    }

    // static getOrders(payload) {
    //     return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront/orders?page=${payload.page}`);
    // }

    static getOrders(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filterBy=${params.filter_by}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        request_params = request_params.slice(1)
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront/orders?${request_params}`);
    }

    static addDepartment(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/departments`, payload);
    }

    static updateDepartment(payload) {
        return InventoryServiceHelper.handlePatchRequest(`${this.API_URI}/departments/${payload.id}/update`, payload);
    }

    static deleteDepartment(id) {
        return InventoryServiceHelper.handleDeleteRequest(`${this.API_URI}/departments/${id}`);
    }

    static allDepartments() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/departments`);
    }

    static getTodayOrders(payload) {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront/orders/today?department=${payload.department}&page=${payload.page}`);
    }

    static assignDepartment(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/storefront/orders/${payload.id}/assign-department`, payload);
    }

    static downloadOrderAnalytics(payload) {
        return InventoryServiceHelper.handleDownloadRequest(`${this.API_URI}/storefront/orders/export-reports?from_date=${payload.from_date}&to_date=${payload.to_date}`, 'Order_Report');
    }

    static getOrderChart() {
        return InventoryServiceHelper.handleGetRequest(`${this.API_URI}/storefront/orders/charts`);
    }

    static updateMerchantDetails(payload) {
        return InventoryServiceHelper.handlePostRequest(`${this.API_URI}/update-organization`, payload);
    }

}